import store from "../store";

let stopDisplay;

export function msgBar(array) {

    return function(dispatch){

        clearTimeout(stopDisplay);

        dispatch({
            type: "MSG_BAR",
            payload: array
        });

        stopDisplay = setTimeout(() => {
            dispatch({
                type: "MSG_BAR",
                payload: []
            })
        }, 5000)

    }
}    

export function gmailAddOnMsgBar(array) {

    return function(dispatch){

        clearTimeout(stopDisplay);

        dispatch({
            type: "GMAIL_ADDON_MSG_BAR",
            payload: array
        });

        stopDisplay = setTimeout(() => {
            dispatch({
                type: "GMAIL_ADDON_MSG_BAR",
                payload: []
            })
        }, 5000)
    }

}

export function msgCommentBar(array) {

    return function(dispatch){

        clearTimeout(stopDisplay);

        dispatch({
            type: "MSG_COMMENT_BAR",
            payload: array
        });

        stopDisplay = setTimeout(() => {
            if(store.getState().msgBarReducer.msgCommentBar.length > 0){
                dispatch({
                    type: "MSG_COMMENT_BAR",
                    payload: []
                })
            }
        }, 5000)

    }
}

export function msgSharingDetailsBar(array) {

	return function(dispatch){

		clearTimeout(stopDisplay);

		dispatch({
			type: "MSG_SHARING_DETAILS_BAR",
			payload: array
		});

		stopDisplay = setTimeout(() => {
			if(store.getState().msgBarReducer.msgSharingDetailsBar.length > 0){
				dispatch({
					type: "MSG_SHARING_DETAILS_BAR",
					payload: []
				})
			}
		}, 5000)

	}
}